import { camelize } from 'helpers/syntaxHelper';
import { CadrageConfigT } from '../config/types';

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with cadrage fetch payloads, by camelizing values
 * in metrics.
 */
export const getCadrageConfigPostProcessingMiddleware = (payload: {
    data: CadrageConfigT;
}) => ({
    ...payload,
    data: {
        ...payload.data,
        metric: camelize(payload.data.metric),
    },
});
